import React, { useState, useEffect } from 'react';

/**
 * Crosshair Overlay Component
 * Displays full-screen crosshair lines following the mouse cursor with coordinates
 */
const CrosshairOverlay = ({ enabled, width, height, color = '#ef4444' }) => {
    const [position, setPosition] = useState({ x: -100, y: -100 });
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!enabled) return;

        const handleMouseMove = (e) => {
            const container = document.getElementById('outLine');
            if (!container) return;

            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            // Check if cursor is within bounds
            if (x >= 0 && x <= width && y >= 0 && y <= height) {
                setPosition({ x, y });
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        const handleMouseLeave = () => {
            setIsVisible(false);
        };

        window.addEventListener('mousemove', handleMouseMove);
        
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, [enabled, width, height]);

    if (!enabled || !isVisible) return null;

    return (
        <div className="absolute inset-0 pointer-events-none z-50 overflow-hidden">
            {/* Horizontal Line */}
            <div 
                className="absolute w-full border-t border-dashed"
                style={{ 
                    top: position.y, 
                    borderColor: color,
                    borderWidth: '1px'
                }}
            />
            
            {/* Vertical Line */}
            <div 
                className="absolute h-full border-l border-dashed"
                style={{ 
                    left: position.x, 
                    borderColor: color, 
                    borderWidth: '1px'
                }}
            />

            {/* Coordinates Label */}
            <div 
                className="absolute bg-gray-900/90 text-white text-[10px] px-2 py-1 rounded font-mono shadow-sm backdrop-blur-sm"
                style={{ 
                    top: position.y + 10, 
                    left: position.x + 10,
                    zIndex: 60
                }}
            >
                X: {Math.round(position.x)} Y: {Math.round(position.y)}
            </div>
            
            {/* Center Dot */}
            <div 
                className="absolute w-1.5 h-1.5 rounded-full -translate-x-1/2 -translate-y-1/2 border border-white"
                style={{ 
                    top: position.y, 
                    left: position.x,
                    backgroundColor: color
                }}
            />
        </div>
    );
};

export default CrosshairOverlay;
